import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { Promo } from '../interfaces/Promo';
import { UserService } from './user.service';
import { RequestsServices } from './requests.service';

@Injectable({
  providedIn: 'root'
})
export class PromoService {

  baseUrl = 'prize_draws';

  constructor(
    private request: RequestsServices,
    private userService: UserService
  ) {}

  private _getAccountId() {
    const loggedUser = this.userService.getLoggedUser() as any;
    return loggedUser.customer ? loggedUser.customer.id : loggedUser.id;
  }

  canParticipate() {
    const account = this.userService.getLoggedAccount();
    return (account && account.prize_draw) && account.prize_draw.status === 'enable';
  }

  getActivePromos(): Observable<Promo[]> {
    return from(this.request.get({path: 'prize_draws', endPoint: '/active'}));
  }

  participate(prizeId) {
    const accountId = this._getAccountId();
    return from(this.request.post('prize_draws', {}, '', `/participate/${prizeId}/user/${accountId}`));
  }

  verify(prizeDrawId): any {
    const accountId = this._getAccountId();
    return from(this.request.get({path: 'prize_draws', custom: `/verify/user/${accountId}/participate/${prizeDrawId}`}));
  }
}
